import * as React from 'react';
import Svg, {Rect, Path, Circle} from 'react-native-svg';
import {shortcutIconColors} from 'src/components/elements/home/ShortcutButton';

const VendingShortcut = () => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
    <Path
      d="M18 1a2 2 0 012 2v18.154a2 2 0 01-2 2H6a2 2 0 01-2-2V3a2 2 0 012-2h12zM6.042 18.774a.4.4 0 00-.4.4v.43c0 .221.18.4.4.4h7.815a.4.4 0 00.4-.4v-.43a.4.4 0 00-.4-.4H6.042zm0-16.143a.4.4 0 00-.4.4v11.823c0 .221.18.4.4.4h7.815a.4.4 0 00.4-.4V3.031a.4.4 0 00-.4-.4H6.042zm10.54 8.008a.4.4 0 00-.4.4v3.816c0 .22.178.399.4.399h1.661a.4.4 0 00.4-.4v-3.816a.4.4 0 00-.4-.4h-1.662zm.83-3.732a1.23 1.23 0 100 2.461 1.23 1.23 0 000-2.46z"
      fill={shortcutIconColors().primaryColor ?? '#0052BF'}
    />
    <Rect
      x={16.1816}
      y={10.627}
      width={2.46154}
      height={4.61576}
      rx={0.4}
      fill={shortcutIconColors().secondaryColor ?? '#58C6BB'}
    />
    <Circle
      cx={17.4124}
      cy={8.138}
      r={1.23077}
      fill={shortcutIconColors().secondaryColor ?? '#58C6BB'}
    />
  </Svg>
);
export default VendingShortcut;
